import React, {createContext} from "react";
import {useUser} from "@/base/components/auth/UserProvider";
import {EmailConfirm} from "@/base/components/dashboard/EmailConfirm";

type Props = {
	children: React.ReactNode
	className?: string
	enableRightSide?: boolean
}

type Context = {
	enableRightSide: boolean
}

const DashboardContext = createContext({} as Context)

const DashboardEntry = {
	Base: function ({children, enableRightSide = true, className}: Props) {
		const UserContext = useUser();

		return (
			<DashboardContext.Provider value={{enableRightSide}}>
				<div className={`grid xl:gap-5 gap-y-5 grid-cols-1 lg:grid-cols-1 lg:min-h-screen ${enableRightSide && `xl:grid-cols-3 2xl:grid-cols-4`} xl:px-3 xl:pl-0 ${className || ''}`}>
					{UserContext.loggedIn && !UserContext.user?.email_verified_at && !UserContext.user?.phone?.is_verified && (
						<EmailConfirm className={`xl:col-span-2 col-span-full`}/>
					)}

					{children}
				</div>
			</DashboardContext.Provider>
		);
	},
	Content: function (props: Props) {
		const {enableRightSide} = React.useContext(DashboardContext);

		return (
			<div className={`${props.className || ''} w-full col-span-2 ${enableRightSide && `2xl:col-span-3`}`}>
				{props.children}
			</div>
		);
	},
	RightSide: function (props: Props) {
		return (
			<div className={`${props.className || ''}`}>
				{props.children}
			</div>
		);
	}
}

export default DashboardEntry;